import React, { useState } from "react";

import { saveProductSet } from "@admin/domain/productSets/api";
import Editor from "@admin/components/Editor";
import Input from "@admin/components/Input";
import Switch from "@admin/components/Switch";
import ProductsSearch from "@admin/components/ProductsSearch";

const LIST_URL = `/admin/product_sets` as const;

type Row = {
    key: string;
    productId: string | null;
    productTitle: string | null;
    unavailable?: boolean;
};

export default function ProductSetEditor() {
    const productSet = window.CMS.productSet || null;

    const initialRows: Array<Row> = (productSet?.items ?? []).map((item) => ({
        key: `item-${item.id}`,
        productId: item.product_id ?? item.original_product_id,
        productTitle: item.title,
        unavailable: item.product_id === null || item.availability === `discontinued`,
    }));

    const [rows, setRows] = useState<Array<Row>>(initialRows);

    const addRow = () => {
        setRows([...rows, { key: `new-${Date.now()}-${rows.length}`, productId: null, productTitle: null }]);
    };

    const removeRow = (key: string) => {
        setRows(rows.filter((row) => row.key !== key));
    };

    const updateRow = (key: string, productId: string | null, productTitle: string | null) => {
        setRows(rows.map((row) => (row.key === key ? { ...row, productId, productTitle, unavailable: false } : row)));
    };

    const selectedIds = rows.map((row) => row.productId).filter((id): id is string => id !== null);

    const execute = async (body: FormData) => {
        await saveProductSet(productSet, body);
    };

    return (
        <Editor backUrl={LIST_URL} onSubmit={execute}>
            <Input label="Название набора" name="title" defaultValue={productSet?.title} maxLength={255} />

            <Switch label="Активен" name="is_active" defaultChecked={productSet ? productSet.is_active : true} />

            <div className="mb-5">
                <label className="form-label d-block">Состав набора</label>

                {rows.map((row, index) => (
                    <div key={row.key} className="d-flex align-items-center mb-3">
                        <div className="flex-grow-1 me-2">
                            {row.unavailable && <p className="text-danger">Товар снят с продажи. Удалите или замените его перед сохранением.</p>}
                            <ProductsSearch
                                inputName={`products[${index}]`}
                                productId={row.productId}
                                productTitle={row.productTitle}
                                excludeProductIds={selectedIds}
                                onChange={(value, label) => updateRow(row.key, value ?? null, label ?? null)}
                            />
                        </div>

                        <button type="button" className="btn btn-danger btn-sm mb-5" onClick={() => removeRow(row.key)}>
                            Удалить
                        </button>
                    </div>
                ))}

                <button type="button" className="btn btn-primary" onClick={addRow}>
                    Добавить товар
                </button>
            </div>
        </Editor>
    );
}
